let login_Online = async function (param) { return window.getAgroTrack.$http.post('/login/', param) };

let api_token_verify = async function () { return window.getAgroTrack.$http.post('/api-token-verify/', { token: localStorage.getItem('access') }) };

let users = async function (param) { return window.getAgroTrack.$http.get('/users/', param) };
let user_delete = async function (id) { return window.getAgroTrack.$http.delete('/users/' + id + '/') };
let user_update = async function (param, id) { return window.getAgroTrack.$http.put('/users/' + id + '/', param) };
let user_post = async function (param) { return window.getAgroTrack.$http.post('/users/', param) };

let regions = async function (param) { return window.getAgroTrack.$http.get('/regions/', param) };
let region_delete = async function (id) { return window.getAgroTrack.$http.delete('/regions/' + id + '/') };
let region_update = async function (param, id) { return window.getAgroTrack.$http.put('/regions/' + id + '/', param) };
let region_post = async function (param) { return window.getAgroTrack.$http.post('/regions/', param) };

let prefectures = async function (param) { return window.getAgroTrack.$http.get('/prefectures/', param) };
let prefecture_delete = async function (id) { return window.getAgroTrack.$http.delete('/prefectures/' + id + '/') };
let prefecture_update = async function (param, id) { return window.getAgroTrack.$http.put('/prefectures/' + id + '/', param) };
let prefecture_post = async function (param) { return window.getAgroTrack.$http.post('/prefectures/', param) };
let prefecture_par_region = async function (param) { console.log('param: ', param); return window.getAgroTrack.$http.post('/prefecture-par-region/', param) };

let cantons = async function (param) { return window.getAgroTrack.$http.get('/cantons/', param) };
let canton_delete = async function (id) { return window.getAgroTrack.$http.delete('/cantons/' + id + '/') };
let canton_update = async function (param, id) { return window.getAgroTrack.$http.put('/cantons/' + id + '/', param) };
let canton_post = async function (param) { return window.getAgroTrack.$http.post('/cantons/', param) };
let canton_filter = async function (param) { return window.getAgroTrack.$http.post('/canton-filter/', param) };

let villages = async function (param) { return window.getAgroTrack.$http.get('/villages/', param) };
let village_delete = async function (id) { return window.getAgroTrack.$http.delete('/villages/' + id + '/') };
let village_update = async function (param, id) { return window.getAgroTrack.$http.put('/villages/' + id + '/', param) };
let village_post = async function (param) { return window.getAgroTrack.$http.post('/villages/', param) };
let village_filter = async function (param) { return window.getAgroTrack.$http.post('/village-filter/', param) };


let cooperatives = async function (param) { return window.getAgroTrack.$http.get('/cooperatives/', param) };
let cooperative_delete = async function (id) { return window.getAgroTrack.$http.delete('/cooperatives/' + id + '/') };
let cooperative_update = async function (param, id) { return window.getAgroTrack.$http.put('/cooperatives/' + id + '/', param) };
let cooperative_post = async function (param) { return window.getAgroTrack.$http.post('/cooperatives/', param) };
let cooperative_filter = async function (param) { return window.getAgroTrack.$http.post('/cooperative-filter/', param) };


let monthss = async function (param) { return window.getAgroTrack.$http.get('/months/', param) };
let months_delete = async function (id) { return window.getAgroTrack.$http.delete('/months/' + id + '/') };
let months_update = async function (param, id) { return window.getAgroTrack.$http.put('/months/' + id + '/', param) };
let months_post = async function (param) { return window.getAgroTrack.$http.post('/months/', param) };

let stores = async function (param) { return window.getAgroTrack.$http.get('/stores/', param) };
let store_delete = async function (id) { return window.getAgroTrack.$http.delete('/stores/' + id + '/') };
let store_update = async function (param, id) { return window.getAgroTrack.$http.put('/stores/' + id + '/', param) };
let store_patch = async function (param, id) { return window.getAgroTrack.$http.patch('/stores/' + id + '/', param) };
let store_post = async function (param) { return window.getAgroTrack.$http.post('/stores/', param) };

let guardians = async function (param) { return window.getAgroTrack.$http.get('/guardians/', param) };
let guardian_delete = async function (id) { return window.getAgroTrack.$http.delete('/guardians/' + id + '/') };
let guardian_update = async function (param, id) { return window.getAgroTrack.$http.put('/guardians/' + id + '/', param) };
let guardian_post = async function (param) { return window.getAgroTrack.$http.post('/guardians/', param) };
let guardian_activation = async function (param) { return window.getAgroTrack.$http.post('/guardian-activation/', param) };


let rents = async function (param) { return window.getAgroTrack.$http.get('/rents/', param) };
let rent_delete = async function (id) { return window.getAgroTrack.$http.delete('/rents/' + id + '/') };
let rent_update = async function (param, id) { return window.getAgroTrack.$http.put('/rents/' + id + '/', param) };
let rent_post = async function (param) { return window.getAgroTrack.$http.post('/rents/', param) };

let securityCharges = async function (param) { return window.getAgroTrack.$http.get('/securityCharges/', param) };
let securityCharge_delete = async function (id) { return window.getAgroTrack.$http.delete('/securityCharges/' + id + '/') };
let securityCharge_update = async function (param, id) { return window.getAgroTrack.$http.put('/securityCharges/' + id + '/', param) };
let securityCharge_post = async function (param) { return window.getAgroTrack.$http.post('/securityCharges/', param) };

let producers = async function (param) { return window.getAgroTrack.$http.get('/producers/', param) };
let producer_delete = async function (id) { return window.getAgroTrack.$http.delete('/producers/' + id + '/') };
let producer_update = async function (param, id) { return window.getAgroTrack.$http.put('/producers/' + id + '/', param) };
let producer_post = async function (param) { return window.getAgroTrack.$http.post('/producers/', param) };

let feeTypes = async function (param) { return window.getAgroTrack.$http.get('/feeTypes/', param) };
let feeType_delete = async function (id) { return window.getAgroTrack.$http.delete('/feeTypes/' + id + '/') };
let feeType_update = async function (param, id) { return window.getAgroTrack.$http.put('/feeTypes/' + id + '/', param) };
let feeType_post = async function (param) { return window.getAgroTrack.$http.post('/feeTypes/', param) };

let packagings = async function (param) { return window.getAgroTrack.$http.get('/packagings/', param) };
let packaging_delete = async function (id) { return window.getAgroTrack.$http.delete('/packagings/' + id + '/') };
let packaging_update = async function (param, id) { return window.getAgroTrack.$http.put('/packagings/' + id + '/', param) };
let packaging_post = async function (param) { return window.getAgroTrack.$http.post('/packagings/', param) };

let paths = async function (param) { return window.getAgroTrack.$http.get('/paths/', param) };
let path_delete = async function (id) { return window.getAgroTrack.$http.delete('/paths/' + id + '/') };
let path_update = async function (param, id) { return window.getAgroTrack.$http.put('/paths/' + id + '/', param) };
let path_post = async function (param) { return window.getAgroTrack.$http.post('/paths/', param) };

let paul_post = async function (param) { return window.getAgroTrack.$http.post('/paul/', param) };

let amounts_post = async function (param) { return window.getAgroTrack.$http.post('/amounts/', param) };


let loans = async function (param) { return window.getAgroTrack.$http.get('/loans/', param) };
let loan_delete = async function (id) { return window.getAgroTrack.$http.delete('/loans/' + id + '/') };
let loan_update = async function (param, id) { return window.getAgroTrack.$http.put('/loans/' + id + '/', param) };
let loan_post = async function (param) { return window.getAgroTrack.$http.post('/loans/', param) };

let paymentTypes = async function (param) { return window.getAgroTrack.$http.get('/paymentTypes/', param) };
let paymentType_delete = async function (id) { return window.getAgroTrack.$http.delete('/paymentTypes/' + id + '/') };
let paymentType_update = async function (param, id) { return window.getAgroTrack.$http.put('/paymentTypes/' + id + '/', param) };
let paymentType_post = async function (param) { return window.getAgroTrack.$http.post('/paymentTypes/', param) };

let security_charge_verify = async function (param) { return window.getAgroTrack.$http.post('/security-charge-verify/', param) };

let guardian_last_endDate = async function (param) { return window.getAgroTrack.$http.post('/guardian-last-endDate/', param) };

let active_guardians = async function (param) { return window.getAgroTrack.$http.get('/active-guardians/', param) };


let storeOutlays = async function (param) { return window.getAgroTrack.$http.get('/storeOutlays/', param) };
let storeOutlay_delete = async function (id) { return window.getAgroTrack.$http.delete('/storeOutlays/' + id + '/') };
let storeOutlay_update = async function (param, id) { return window.getAgroTrack.$http.put('/storeOutlays/' + id + '/', param) };
let storeOutlay_post = async function (param) { return window.getAgroTrack.$http.post('/storeOutlays/', param) };

let otherFees = async function (param) { return window.getAgroTrack.$http.get('/otherFees/', param) };
let otherFee_delete = async function (id) { return window.getAgroTrack.$http.delete('/otherFees/' + id + '/') };
let otherFee_update = async function (param, id) { return window.getAgroTrack.$http.put('/otherFees/' + id + '/', param) };
let otherFee_post = async function (param) { return window.getAgroTrack.$http.post('/otherFees/', param) };

let seedLoans = async function (param) { return window.getAgroTrack.$http.get('/seedLoans/', param) };
let seedLoan_delete = async function (id) { return window.getAgroTrack.$http.delete('/seedLoans/' + id + '/') };
let seedLoan_update = async function (param, id) { return window.getAgroTrack.$http.put('/seedLoans/' + id + '/', param) };
let seedLoan_post = async function (param) { return window.getAgroTrack.$http.post('/seedLoans/', param) };


let seedPrices = async function (param) { return window.getAgroTrack.$http.get('/seedPrices/', param) };

let totalAmountSeeds = async function (param) { return window.getAgroTrack.$http.post('/totalAmountSeeds/', param) };

let products = async function (param) { return window.getAgroTrack.$http.get('/products/', param) };
let product_delete = async function (id) { return window.getAgroTrack.$http.delete('/products/' + id + '/') };
let product_update = async function (param, id) { return window.getAgroTrack.$http.put('/products/' + id + '/', param) };
let product_post = async function (param) { return window.getAgroTrack.$http.post('/products/', param) };

let typeOfPaths = async function (param) { return window.getAgroTrack.$http.get('/typeOfPaths/', param) };
let typeOfPath_delete = async function (id) { return window.getAgroTrack.$http.delete('/typeOfPaths/' + id + '/') };
let typeOfPath_update = async function (param, id) { return window.getAgroTrack.$http.put('/typeOfPaths/' + id + '/', param) };
let typeOfPath_post = async function (param) { return window.getAgroTrack.$http.post('/typeOfPaths/', param) };

let traceabilities = async function (param) { return window.getAgroTrack.$http.get('/traceabilities/', param) };
let traceabilitie_delete = async function (id) { return window.getAgroTrack.$http.delete('/traceabilities/' + id + '/') };
let traceabilitie_update = async function (param, id) { return window.getAgroTrack.$http.put('/traceabilities/' + id + '/', param) };
let traceabilitie_post = async function (param) { return window.getAgroTrack.$http.post('/traceabilities/', param) };

let path_deactivations = async function (param) { return window.getAgroTrack.$http.post('/path-deactivations/', param) };

let store_endDate = async function (param) { return window.getAgroTrack.$http.post('/store-endDate/', param) };

let rent_verify = async function (param) { return window.getAgroTrack.$http.post('/rent-verify/', param) };

let fees = async function (param) { return window.getAgroTrack.$http.get('/fees/', param) };
let fee_delete = async function (id) { return window.getAgroTrack.$http.delete('/fees/' + id + '/') };
let fee_update = async function (param, id) { return window.getAgroTrack.$http.put('/fees/' + id + '/', param) };
let fee_post = async function (param) { return window.getAgroTrack.$http.post('/fees/', param) };

let active_paths = async function (param) { return window.getAgroTrack.$http.get('/active-paths/', param) };

let against_weighings = async function (param) { return window.getAgroTrack.$http.post('/against-weighings/', param) };

let purchases = async function (param) { return window.getAgroTrack.$http.get('/purchases/', param) };
let purchase_delete = async function (id) { return window.getAgroTrack.$http.delete('/purchases/' + id + '/') };
let purchase_update = async function (param, id) { return window.getAgroTrack.$http.put('/purchases/' + id + '/', param) };
let purchase_post = async function (param) { return window.getAgroTrack.$http.post('/purchases/', param) };

let farms = async function (param) { return window.getAgroTrack.$http.get('/farms/', param) };
let farm_delete = async function (id) { return window.getAgroTrack.$http.delete('/farms/' + id + '/') };
let farm_update = async function (param, id) { return window.getAgroTrack.$http.put('/farms/' + id + '/', param) };
let farm_post = async function (param) { return window.getAgroTrack.$http.post('/farms/', param) };

let userList = async function (param) { return window.getAgroTrack.$http.get('/userList/', param) };

let achat_enCours = async function (param) { return window.getAgroTrack.$http.post('/achat-enCours/', param) };

let user_paths = async function (param) { return window.getAgroTrack.$http.post('/user-paths/', param) };

let user_traceabilities = async function (param) { return window.getAgroTrack.$http.post('/user-traceabilities/', param) };

let seasons = async function (param) { return window.getAgroTrack.$http.get('/seasons/', param) };
let season_delete = async function (id) { return window.getAgroTrack.$http.delete('/seasons/' + id + '/') };
let season_update = async function (param, id) { return window.getAgroTrack.$http.put('/seasons/' + id + '/', param) };
let season_post = async function (param) { return window.getAgroTrack.$http.post('/seasons/', param) };

let season_activation = async function (param) { return window.getAgroTrack.$http.post('/season-activation/', param) };

let provisionalPrices = async function (param) { return window.getAgroTrack.$http.get('/provisionalPrices/', param) };
let provisionalPrice_delete = async function (id) { return window.getAgroTrack.$http.delete('/provisionalPrices/' + id + '/') };
let provisionalPrice_update = async function (param, id) { return window.getAgroTrack.$http.put('/provisionalPrices/' + id + '/', param) };
let provisionalPrice_post = async function (param) { return window.getAgroTrack.$http.post('/provisionalPrices/', param) };

let agentStocks = async function (param) { return window.getAgroTrack.$http.get('/agentStocks/', param) };

let path_purchases = async function (param) { return window.getAgroTrack.$http.get('/path-purchases/', param) };
let path_traceabilities = async function (param) { return window.getAgroTrack.$http.get('/path-traceabilities/', param) };
let pathHasPackaging_enter_list = async function (param) { return window.getAgroTrack.$http.get('/pathHasPackaging-enter-list/', param) };
let agentStock_output_list = async function (param) { return window.getAgroTrack.$http.get('/agentStock-output-list/', param) };

let dashboard = async function (param) { return window.getAgroTrack.$http.get('/dashboard/', param) };

// user-traceabilities
export default {
  dashboard,
  
  agentStock_output_list,
  
  pathHasPackaging_enter_list,

  path_traceabilities,
  
  path_purchases,

  agentStocks,

  provisionalPrice_update,
  provisionalPrice_post,
  provisionalPrices,
  provisionalPrice_delete,

  season_activation,

  season_update,
  season_post,
  seasons,
  season_delete,

  user_traceabilities,
  
  user_paths,
  
  achat_enCours,
  
  userList,

  farm_update,
  farm_post,
  farms,
  farm_delete,

  purchase_update,
  purchase_post,
  purchases,
  purchase_delete,

  against_weighings,

  active_paths,

  fee_update,
  fee_post,
  fees,
  fee_delete,

  rent_verify,

  store_endDate,

  path_deactivations,

  traceabilitie_update,
  traceabilitie_post,
  traceabilities,
  traceabilitie_delete,

  typeOfPath_update,
  typeOfPath_post,
  typeOfPaths,
  typeOfPath_delete,

  product_update,
  product_post,
  products,
  product_delete,

  totalAmountSeeds,

  seedPrices,

  seedLoan_update,
  seedLoan_post,
  seedLoans,
  seedLoan_delete,

  otherFee_update,
  otherFee_post,
  otherFees,
  otherFee_delete,

  storeOutlay_update,
  storeOutlay_post,
  storeOutlays,
  storeOutlay_delete,

  active_guardians,

  guardian_last_endDate,

  security_charge_verify,

  paymentType_update,
  paymentType_post,
  paymentTypes,
  paymentType_delete,

  loan_update,
  loan_post,
  loans,
  loan_delete,

  amounts_post,

  paul_post,

  path_update,
  path_post,
  paths,
  path_delete,

  packaging_update,
  packaging_post,
  packagings,
  packaging_delete,

  feeType_update,
  feeType_post,
  feeTypes,
  feeType_delete,

  producer_update,
  producer_post,
  producers,
  producer_delete,

  securityCharge_update,
  securityCharge_post,
  securityCharges,
  securityCharge_delete,

  rent_update,
  rent_post,
  rents,
  rent_delete,
  
  guardian_update,
  guardian_activation,
  guardian_post,
  guardians,
  guardian_delete,

  store_update,
  store_patch,
  store_post,
  stores,
  store_delete,

  months_update,
  months_post,
  monthss,
  months_delete,

  cooperative_update,
  cooperative_post,
  cooperatives,
  cooperative_delete,
  cooperative_filter,

  village_update,
  village_post,
  villages,
  village_delete,
  village_filter,

  canton_update,
  canton_post,
  cantons,
  canton_delete,
  canton_filter,

  prefecture_update,
  prefecture_post,
  prefectures,
  prefecture_delete,
  prefecture_par_region,

  region_update,
  region_post,
  regions,
  region_delete,

  user_update,
  user_post,
  users,
  user_delete,

  login_Online,
  api_token_verify,
};